
import Vue from 'vue'

export default Vue.extend({
  name: 'App',
  components: {},
  data: () => ({
    //
  }),
  created () {
    this.$store.commit('CHANGE_LOADING', false)
  }
})
